import React, { useState, useCallback, useContext, useMemo, useEffect } from 'react';
import ItemLibrary from '../ItemLibrary/ItemLibrary';
import ModalDetail from '../ModalDetail/ModalDetail';
import {AuthenticationContext} from '../AuthenticationContextProvider';
import {LocaleContext} from '../LocaleContextProvider';
import {ConfigContext} from '../ConfigContextProvider';
import { IntlProvider, FormattedMessage , injectIntl} from 'react-intl';
import {
  NavLink,
  Link
} from "react-router-dom";

const HomePage = (props) => {
const {PRODUCTS_URL} = useContext(ConfigContext);
const {ASSETS_URL} = useContext(ConfigContext);

const {favorites, setFavorites, userOptions} = useContext(AuthenticationContext);
const {locale} = useContext(LocaleContext);
const {dataList} = props;


//style={{backgroundImage: `url("${ASSETS_URL}/home.jpg") ` }}
useEffect(() => {

  }, []);

  return (
    <div className="HomePage" >

        <div className="HomePage__textContent">
          <div className="container">
          <h2 className="HomePage__title"><FormattedMessage id={"homepage.title"} /></h2>
          <h3 className="HomePage__subtitle" dangerouslySetInnerHTML={  {__html: props.intl.formatMessage({id: "homepage.subtitle"})}  } ></h3>
          <p className="HomePage__description" dangerouslySetInnerHTML={  {__html: props.intl.formatMessage({id: "homepage.description"})}  } />
          <NavLink to={props.to} className="HomePage__btn"><FormattedMessage id={"homepage.cta"} /></NavLink>
          </div>
        </div>

    </div>
  );

}

export default injectIntl(HomePage);